module.exports = __webpack_public_path__ + "img/quatrieme-les-pierres-de-memoires.76dce06d.png";